import axios from "axios";

const endpoint = `${process.env.REACT_APP_API_URL}/smq/Suivi`;

const payload = (response) => {
  if (response?.data?.status === false) {
    throw new Error(response.data.message || "Une erreur est survenue");
  }
  return response?.data;
};

const errorMessage = (error) =>
  error?.response?.data?.message ||
  error?.message ||
  "Le service de suivi d’efficacité est indisponible";

const request = async (callback) => {
  try {
    return payload(await callback());
  } catch (error) {
    throw new Error(errorMessage(error));
  }
};

const SuiviService = {
  getAll() {
    return request(() => axios.get(endpoint));
  },

  getDetail(constatId) {
    return request(() => axios.get(`${endpoint}/${constatId}`));
  },

  create(data) {
    return request(() => axios.post(endpoint, data));
  },

  update(suiviId, data) {
    return request(() => axios.put(`${endpoint}/${suiviId}`, data));
  },

};

export default SuiviService;
